import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import GenericModal from '../../GenericModal'

import BrokerComparisonTable from './BrokerComparisonTable'

export class BrokerComparisonDialog extends Component {

  cancelElectionHandler = (callback) => {
    this.props.onCloseDialog()
  }

  completeAtBrokerHandler = (callback) => {
    this.props.onCloseDialog()
  }

  render() {
    const { t } = this.props;

    return (
      <GenericModal
        title={t("AvailableBrokers.BrokerComparisonTitle")}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="broker-comparison"
      >
        <BrokerComparisonTable/>
      </GenericModal>
    )
  }
}

export default withTranslation('translations')(BrokerComparisonDialog)

